import { Country } from '@/models/country';
import type { AiModelContent } from '../aiLeagueTypes';
import placeholderImage from '@/assets/ai-league/placeholder.svg';

export const FABLE5_AI_CONTENT: AiModelContent = {
  id: 'fable5',
  tabLabel: 'Fable 5',
  displayName: 'Fable 5',
  countryList: [
    Country.ES,
    Country.FR,
    Country.GB_ENG,
    Country.AR,
    Country.NO,
    Country.CO,
    Country.UY,
    Country.MA,
    Country.TR,
    Country.CZ,
  ],
  listValid: true,
  responseTimeSeconds: 230,
  imageSrc: placeholderImage,
  justificationText: `Methodology

I modeled expected raw points per team (cumulative progression bonuses + 3/win + 1/goal) using June 2026 betting markets, Opta's supercomputer, and the actual group draw, then sorted by EV so the highest expected scorers get the biggest multipliers. Progression points compound (a champion banks ~63 progression points alone), so elite teams are worth 2–3x the best mid-tier teams — hence the 4/4/2 structure: max out Seeds, take only the mandatory 2 Outsiders.

Spain (+450, soft group H, heavy scorers) and France (+475) are the market's clear top two and hedge each other across their projected semifinal; England (+700, Tuchel, kind group) and Argentina (+900, gentle group J) hedge the other half — I likely own both finalists. Norway is the standout non-seed (Opta 3.5% champion, 37 qualifying goals, Haaland's goal volume monetizes the +1/goal rule even if they exit in the R16). Colombia and Uruguay face one giant plus minnows each, making R16+ likely. Morocco (2022 semifinalists, elite defense, Hakimi) should cruise past Scotland/Haiti. Türkiye is comfortably the strongest Outsider (~+9000, Euro 2024 quarterfinalists, winnable Group D); Czechia sits in the tournament's softest group (Mexico/Korea/South Africa).

Key assumptions: markets are well-calibrated; goals/wins roughly track progression odds.

Biggest risk: concentration — Spain at x10 means one quarterfinal upset craters the entry, and Norway at x6 must escape the France–Senegal group, the entry's most fragile leg.`,
};
